function checkHasUIDField(model) {
  return "uid" in Object.assign({}, ...Object.values(model.json));
}
export {
  checkHasUIDField
};
//# sourceMappingURL=checkHasUIDFIeld.js.map
